<div class="single__page">
    <img width="10%" src="/assets/images/eurofarma-assets/eurofarma.png" alt="Eurofarma logo">
    <p>
        Escolha a forma como deseja acessar o sistema.
    </p>
    <a [routerLink]="['/authenticate', 'office']">
        Acesso via e-mail <strong>Eurofarma</strong>
    </a>
</div>
